<template>
  <v-container fluid>
    <v-card flat class="custom-grey-border remove-border-radius" :disabled="pageLoading">
      <v-card-title class="headline grey lighten-4" @click="isOpen = !isOpen">
        <h3 class="font-weight-700 custom-headline color-custom-blue">
          <v-icon>
            {{ !isOpen ? "mdi-chevron-down" : "mdi-chevron-up" }}
          </v-icon>
          Delivery Note & Remark
        </h3>
      </v-card-title>
      <v-expand-transition>
        <v-card-text v-show="isOpen" class="p-4 font-size-16">
          <v-row>
            <v-col cols="12" md="6">
              <v-card flat class="blue lighten-5 pa-4 fill-height">
                <label class="font-weight-700 color-custom-blue">Delivery Note</label>
                <editor v-model="notes.delivery_note" />
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card flat class="green lighten-5 pa-4 fill-height">
                <label class="font-weight-700 color-custom-blue">Remark</label>
                <editor v-model="notes.remark" />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import TinyMCE from "@/view/pages/partials/TinyMCE.vue";

export default {
  name: "purchase-order-delivery-note-remark",
  components: { editor: TinyMCE },
  props: {
    pageLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
    updateData: {
      type: Object,
      default: () => new Object(),
    },
  },
  data() {
    return {
      isOpen: true,
      notes: {
        delivery_note: null,
        remark: null,
      },
    };
  },
  watch: {
    notes: {
      deep: true,
      handler(value) {
        this.$emit("update", Object.assign({}, value));
      },
    },
    updateData: {
      deep: true,
      immediate: true,
      handler(value) {
        this.notes = {
          delivery_note: value.delivery_note || null,
          remark: value.remark || null,
        };
      },
    },
  },
};
</script>
